import { render, staticRenderFns } from "./PickingDetail.vue?vue&type=template&id=6821d222&scoped=true&"
import script from "./PickingDetail.vue?vue&type=script&lang=js&"
export * from "./PickingDetail.vue?vue&type=script&lang=js&"
import style0 from "./PickingDetail.vue?vue&type=style&index=0&id=6821d222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6821d222",
  null
  
)

export default component.exports